export default __webpack_public_path__ + "static/media/Resume.9d703716.pdf";